import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlickSlider = ({ images }) => {
  const rootImagesPath = process.env.REACT_APP_ROOT_IMAGES_PATH || "";

  const settings = {
    dots: true,
    infinite: images?.length > 1,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: images?.length > 1,
    autoplaySpeed: 3000,
    arrows: images?.length > 1,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: true,
  };

  if (!images || images.length === 0) {
    return (
      <div className="gog-carousel-empty">
        No merchant images available.
      </div>
    );
  }

  return (
    <div className="gog-slick-slider-wrap">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div className="gog-slick-slide" key={`${img.imageName}-${index}`}>
            <img
              src={`${rootImagesPath}${img.clientId}/${img.imageName}`}
              alt={img.imageName || `Merchant gallery ${index + 1}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SlickSlider;